import merge from 'lodash/merge';

import applicationConfiguration from './application-configuration';
import applicationLocalization from './application-localization';

export default applicationContext => {
    const defaults = {
        applicationId: 'pulse',
        applicationName: 'PULSE',
        applicationConfiguration,
        applicationLocalization,
    };

    return merge(defaults, applicationContext);
};
